import { FunctionComponent } from "react";

import type { DetailRows } from "./exportDetails";

/** A profile tab's rows laid out for a PDF. */
const DetailsPrint: FunctionComponent<{ title?: string; rows: DetailRows }> = ({
  title,
  rows,
}) => (
  <div>
    {title ? (
      <h3 className="px-4 text-base font-semibold leading-7 text-gray-900 sm:px-0">
        {title}
      </h3>
    ) : null}
    <dl className="mt-6 divide-y divide-gray-100 border-t border-gray-100">
      {rows.map(([label, value]) => (
        <div
          key={label}
          className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0"
        >
          <dt className="text-sm font-medium leading-6 text-gray-900">
            {label}
          </dt>
          <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
            {value}
          </dd>
        </div>
      ))}
    </dl>
  </div>
);

export default DetailsPrint;
